import { Check } from "lucide-react";

export const Field = ({ label, required, children, testid }) => (
  <label className="block" data-testid={testid}>
    <span className="mb-1.5 block text-sm font-semibold text-olive">
      {label} {required && <span className="text-burgundy">*</span>}
    </span>
    {children}
  </label>
);

export const Chip = ({ checked, onToggle, label, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onToggle}
    aria-pressed={checked}
    className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-all duration-200 ${
      checked
        ? "border-olive bg-olive text-cream"
        : "border-linen bg-cream text-moss hover:border-olive/50"
    }`}
  >
    {checked && <Check className="h-3.5 w-3.5" />}
    {label}
  </button>
);

export const RadioPill = ({ name, value, selected, onSelect, label, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={() => onSelect(value)}
    aria-pressed={selected === value}
    className={`rounded-xl border px-5 py-2.5 text-sm font-medium transition-all duration-200 ${
      selected === value
        ? "border-burgundy bg-burgundy text-cream"
        : "border-linen bg-cream text-moss hover:border-burgundy/50"
    }`}
    name={name}
  >
    {label}
  </button>
);

export const FormSection = ({ number, title, children }) => (
  <section className="rounded-2xl border border-linen bg-white/60 p-6 sm:p-8">
    <div className="mb-6 flex items-baseline gap-3">
      <span className="font-serif text-2xl italic text-burgundy">{number}</span>
      <h2 className="font-serif text-xl text-olive sm:text-2xl">{title}</h2>
    </div>
    <div className="space-y-5">{children}</div>
  </section>
);

export const SuccessPanel = ({ title, message, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-olive/30 bg-beige p-10 text-center">
    <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-olive">
      <Check className="h-8 w-8 text-cream" />
    </div>
    <h2 className="font-serif text-3xl text-olive">{title}</h2>
    <p className="mx-auto mt-3 max-w-md text-moss">{message}</p>
  </div>
);
